import firebase from "firebase/app";
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import "firebase/auth"
import 'firebase/storage';  // <----

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};


//TO DO HANDLE CASE WHERE ENVIRONMENT ISN'T DEV OR PROD


// This is our firebaseui configuration object
const uiConfig = ({
    callbacks: {
        signInSuccessWithAuthResult: function () {
            return false; // or true --> redirect
        },
    },
    signInFlow: 'popup', //redirect
    signInSuccessUrl: '/', //url_to_main
    signInOptions: [
        // GOOGLE
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // FACEBOOK
        {
            provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            // Whether the display name should be displayed in the Sign Up page.
            requireDisplayName: true,
        },
    ],
    tosUrl: function () {
        window.location.assign('https://cocoparks.io/terms');
    },
    privacyPolicyUrl: function () {
        window.location.assign('https://cocoparks.io/privacy');
    }
})

//initialize Firebase
firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const storageRef = firebase.storage().ref();
export const storage = firebase.storage();


const ui = new firebaseui.auth.AuthUI(firebase.auth())
// This adds firebaseui to the page
// It does everything else on its own
export const startFirebaseUI = function (elementId) {
    ui.start(elementId, uiConfig)
}

export default firebase
